export function authHeader () {
  let user = JSON.parse(localStorage.getItem('user'))
  if (user && user.token) {
    return {
      'Authorization': 'Bearer ' + user.token
    }
  } else {
    return {}
  }
}



// WEBPACK FOOTER //
// ./src/_helpers/auth-header.js